import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

// Validation schemas matching the domain models
const ValidationErrorContextSchema = z.object({
  sectionName: z.string().optional(),
  columnHeader: z.string().optional(),
  rowIndex: z.number().optional(),
  colIndex: z.number().optional(),
  field: z.string().optional(),
  value: z.unknown().optional(),
});

const ValidationWarningContextSchema = z.object({
  sectionName: z.string().optional(),
  columnHeader: z.string().optional(),
  rowIndex: z.number().optional(),
  colIndex: z.number().optional(),
  originalValue: z.unknown().optional(),
  truncatedValue: z.unknown().optional(),
});

const ValidationErrorSchema = z.object({
  type: z.enum(["required_missing", "mapping_missing", "invalid_expression", "invalid_format"]),
  message: z.string(),
  context: ValidationErrorContextSchema.optional(),
});

const ValidationWarningSchema = z.object({
  type: z.enum(["truncated", "empty_section", "format_conversion"]),
  message: z.string(),
  context: ValidationWarningContextSchema.optional(),
});

// Response schemas
export const ExportValidationErrorSchema = z.object({
  success: z.literal(false),
  errors: z.array(ValidationErrorSchema),
  warnings: z.array(ValidationWarningSchema),
});

export const exportContract = c.router({
  exportQuote: {
    method: "POST",
    path: "/quotes/:id/exports",
    body: z.object({}),
    responses: {
      200: c.otherResponse({
        contentType: "application/zip",
        body: c.type<Buffer>(),
      }),
      400: ExportValidationErrorSchema,
      204: z.void(),
    },
  },
  exportConsultation: {
    method: "POST",
    path: "/quotes/:id/exports-consultation",
    body: z.object({
      quoteRequestLineIds: z.string().uuid().array().optional(),
    }),
    responses: {
      200: c.otherResponse({
        contentType: "application/zip",
        body: c.type<Buffer>(),
      }),
      400: ExportValidationErrorSchema,
      204: z.void(),
    },
  },
});
